import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { UnpublishedRounded } from "@mui/icons-material";

const UnpublishConfirmDialog = ({
  open,
  isDarkMode,
  isUnpublishing,
  agentName,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 600,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: isDarkMode
            ? "rgba(255,255,255,0.02)"
            : "rgba(0,0,0,0.02)",
        }}
      >
        Unpublish Agent
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Poppins", sans-serif',
              fontWeight: 600,
              mb: 1.5,
              color: isDarkMode ? "#ffffff" : "#111827",
            }}
          >
            Are you sure you want to unpublish this agent?
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontFamily: '"Poppins", sans-serif',
              color: isDarkMode ? "#9ca3af" : "#4b5563",
              maxWidth: 520,
              mx: "auto",
              lineHeight: 1.7,
            }}
          >
            Unpublishing will disable Agent API access and remove this agent from
            integrations until it is published again. You can republish at any time.
            {agentName ? `\n\nAgent: ${agentName}` : ""}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          justifyContent: "center",
          gap: 1.5,
        }}
      >
        <Button
          onClick={onClose}
          disabled={isUnpublishing}
          sx={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 600,
            minWidth: 120,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={isUnpublishing}
          startIcon={
            isUnpublishing ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <UnpublishedRounded />
            )
          }
          sx={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 700,
            minWidth: 180,
            backgroundColor: "#e36250",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#d14e3c",
            },
            "&.Mui-disabled": {
              backgroundColor: "rgba(227, 98, 80, 0.5)",
              color: "rgba(255, 255, 255, 0.7)",
            },
          }}
        >
          {isUnpublishing ? "Unpublishing..." : "Yes, unpublish"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnpublishConfirmDialog;
